import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { ProductoEstado } from '../../../_models/producto-estado';
import { ProductoEstadoService } from '../../../_services/producto-estado.service';
import { EstadoService } from '../../../_services/estado.service';
import { Estado } from '../../../_models/estado';

@Component( {
  selector: 'app-producto-estado-aliado',
  templateUrl: 'producto-estado-aliado.component.html'
} )

export class ProductoEstadoAliadoComponent implements OnInit {

  @Input() producto: Producto;
  @Input() aliado: boolean;
  lisEstados: SelectItem[] = [];
  lisEstadosTodos: Estado[] = [];
  carInformacionInicial = true;
  lisProductosEstados: ProductoEstado[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  proEstadoSeleccionado: ProductoEstado;
  seccion = 'LISTADO';

  constructor( private proEstadoServicio: ProductoEstadoService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private estServicio: EstadoService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreEstado', header: this.navServicio.buscarMensaje( 'PRODUCTOESTADO.LBL_ESTADO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proEstadoServicio.listadoPorProducto( this.producto.idProducto ), this.estServicio.listado() ).subscribe( ( [ lisProductosEstados, lisEstados ] ) => {
      this.lisEstadosTodos = lisEstados;
      this.lisProductosEstados = lisProductosEstados;
      this.cargarFormulario();
      this.cargarListadoEstados();
      this.carInformacionInicial = false;
    } );
  }

  cargarListadoEstados() {
    this.lisEstados = [];
    this.lisEstadosTodos.map( ( s: Estado ) => {
      if ( /* (!this.aliado || s.indicadorAliado === this.aliado) && */ !this.lisProductosEstados.find( x => x.idEstado === s.idEstado ) ) {
        this.lisEstados.push( { label: s.nombre, value: s.idEstado } );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idEstados: [ [], this.proEstadoSeleccionado ? [] : [ Validators.required ] ],
      idProductoEstado: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.idProductoEstado : null ],
      idProducto: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.idProducto : this.producto.idProducto, this.proEstadoSeleccionado ? [ Validators.required ] : [] ],
      idEstado: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.idEstado : null, this.proEstadoSeleccionado ? [ Validators.required ] : [] ],
      indicadorHabilitado: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.indicadorHabilitado : true ],
      indicadorAliado: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.indicadorAliado : this.aliado ],
      auditoriaUsuario: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.auditoriaUsuario : null ],
      auditoriaFecha: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.auditoriaFecha : null ],
      indicadorEstadoFinal: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.indicadorEstadoFinal : false ],
      nombreEstado: [ this.proEstadoSeleccionado ? this.proEstadoSeleccionado.nombreEstado : null ],
    } );

  }

  get f() {
    return this.formulario.controls;
  }

  editar( proEstado: ProductoEstado ) {
    this.proEstadoSeleccionado = proEstado;
    this.submitted = false;
    this.cargarFormulario();
  }

  relacionar( proEstado: ProductoEstado ) {
    this.proEstadoSeleccionado = proEstado;
    this.seccion = 'RELACIONAR';
    this.submitted = false;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const proEstadoCrear = this.formulario.value;
      if ( proEstadoCrear.idProductoEstado ) {
        if ( !proEstadoCrear.indicadorHabilitado && this.producto.indicadorHabilitado && this.lisProductosEstados.filter( x => x.indicadorHabilitado ).length === 1 ) {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
          } );
          this.guardando = false;
        } else {
          this.proEstadoServicio.actualizar( proEstadoCrear ).subscribe( estado => {
            const a = this.lisProductosEstados.findIndex( x => x.idProductoEstado === proEstadoCrear.idProductoEstado );
            if ( a >= 0 ) {
              this.lisProductosEstados[ a ].indicadorHabilitado = proEstadoCrear.indicadorHabilitado;
            }

            this.proEstadoSeleccionado = null;
            this.cargarFormulario();
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 2 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        }
      } else {
        let estAgregar = [];
        if ( proEstadoCrear.idEstados ) {
          proEstadoCrear.idEstados.map( s => {
            const regAgregar = {
              idProducto: this.producto.idProducto,
              idEstado: s,
              indicadorHabilitado: proEstadoCrear.indicadorHabilitado,
              indicadorAliado: this.aliado
            };
            estAgregar.push( regAgregar );
          } );
        }
        if ( estAgregar.length > 0 ) {
          this.proEstadoServicio.bulk( estAgregar ).subscribe( estados => {
            estados.map( ( s: ProductoEstado ) => {
              const d = this.lisEstadosTodos.find( x => x.idEstado === s.idEstado );
              if ( d ) {
                s.nombreEstado = d.nombre;
                s.indicadorEstadoFinal = d.indicadorEstadoFinal;
              }
              this.lisProductosEstados = [ ...this.lisProductosEstados, s ];
            } );
            this.proEstadoSeleccionado = null;
            this.cargarFormulario();
            this.cargarListadoEstados();
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        } else {
          this.navServicio.setMesage( 1 );
          this.submitted = false;
          this.guardando = false;
        }
      }

    }
  }

  regresar() {
    this.location.back();
  }

  cambioSeccion( event: boolean ) {
    this.proEstadoSeleccionado = null;
    this.cargarFormulario();
    this.seccion = 'LISTADO';
  }
}
